// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3bnKg","col":"styles_col__U-Xm8"};